export default __webpack_public_path__ + "locales/el-GR/ChangePhoneDialog.json?hash=f135ecde532b05e78a1b85448be0a1c2";